// HTTP for local
const ALLOWED_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:'];

// Links built from stored or submitted data must not run script (e.g. "javascript:" from a public form)
const safeExternalHref = (value?: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }
  try {
    const { protocol } = new URL(value, window.location.origin);
    return ALLOWED_PROTOCOLS.includes(protocol) ? value : undefined;
  } catch {
    return undefined;
  }
};

export default safeExternalHref;
